function initHeaderTariffDescriptionShowMore() {
    if (!document.querySelector('.header-tariff__description')) return;

    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('show-more-btn')) {
            const container = e.target.closest('.header-tariff__description');

            const textBlock = container.querySelector('.header-tariff__description-text');
            const button = container.querySelector('.show-more-btn');

            if (textBlock) {
                textBlock.classList.toggle('text-collapsed');
            }

            if (button) {
                if (textBlock.classList.contains('text-collapsed')) {
                    button.textContent = 'Показать полностью';
                } else {
                    button.textContent = 'Скрыть';
                }
            }
        }
    });
}

export default initHeaderTariffDescriptionShowMore;
